import { render, staticRenderFns } from "./ProjectAdd.vue?vue&type=template&id=720a05f7&scoped=true&"
import script from "./ProjectAdd.vue?vue&type=script&lang=js&"
export * from "./ProjectAdd.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ProjectAdd.vue?vue&type=style&index=1&id=720a05f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720a05f7",
  null
  
)

export default component.exports